import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
//import {AlertProvider} from 'react-native-async-alert';
//import {useShowAlert} from 'react-native-async-alert';
import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');



const RenderStartLcrapp = () => {


const resturl=sessionStorage.getItem("RESTURL");
const navWpapps = React.useRef();

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [tblwpfverify, setTblwpfverify] = useState([]);
const [renders, setRenders] = useState({count:0});
const [wptapp, setWptapp] = useState({WPT_APP_ID:0, TRY_FIND_PERSON_ID:false, PERSON_ID_FROM_LIST:0});
const [dowait, setDowait] = useState({show: false});
const [dowaitdl, setDowaitdl] = useState({show: false});
const [selectedFiles, setSelectedFiles] = useState([]);
const [countryoptions, setCountryoptions] = useState([]);
const [agencyoptions, setAgencyoptions] = useState([]);
const [payperiodoptions, setPayperiodoptions] = useState([]);
const [occupationoptions, setOccupationoptions] = useState([]);
const [lcrtypeoptions, setLcrtypeoptions] = useState([]);
const [locationoptions, setLocationoptions] = useState([]);
const [statusoptions, setStatusoptions] = useState([]);
const [reviewtypeoptions, setReviewtypeoptions] = useState([]);
const [tblperson, setTblperson] = useState([]);

const [genderoptions, setGenderoptions] = useState([
<option key="gender1" value='Female' >Female</option>
,<option key="gender2" value='Male' >Male</option>
]);

const [yesnooptions, setYesnooptions] = useState([
<option key="yesno1" value='1' >Yes</option>
,<option key="yesno2" value='0' >No</option>
]);

const [progress, setProgress] = useState({
perct:null
});
//const [city, setCity] = useState({name:''});



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "APS Labour Clearance";	

let WPT_APP_ID=null ;//26
if (location.state)
	if (location.state.WPT_APP_ID)
		WPT_APP_ID=location.state.WPT_APP_ID;


console.log("location WPT_APP_ID: "+WPT_APP_ID);
if (WPT_APP_ID)
	setWptapp((prev)=>{
		return {
			...prev
			, WPT_APP_ID: WPT_APP_ID
			}
	});

checkMedRec();
/*
if (location.state.WPT_APP_ID!=null && location.state.WPT_APP_ID!=undefined && location.state.WPT_APP_ID!='null' && location.state.WPT_APP_ID!='undefined'){
	setWptapp({WPT_APP_ID:location.state.WPT_APP_ID});
	}//end if
else
	console.log("location.state.WPT_APP_ID not provided");
*/

	
 },[]);

useEffect(() => {

if (tblperson.length>0)
	toggleModalsm();

 },[JSON.stringify(tblperson)]);
 
useEffect(() => {
//console.log("useEffect"+wptapp.WPT_APP_ID);
if (!wptapp)
	return;

if (!wptapp.WPT_APP_ID)
	return;

if ((""+wptapp.WPT_APP_ID).trim()=="undefined")
	return;	

	console.log('useEffect wptapp.WPT_APP_ID: '+wptapp.WPT_APP_ID)
	if (wptapp.REF_NUM==undefined)
		getwptapp();
	else if (countryoptions.length==0){
		const evt={currentTarget:document.getElementById("person")};
		openCity(evt, "persontc");
		getlcrstartoptions();
		}
	else{
		if (wptapp.TRY_FIND_PERSON_ID==true)
			if (wptapp.MPE_FIRST_NAME!="" && wptapp.MPE_LAST_NAME!="" && wptapp.MPE_DOB!="" && wptapp.MPE_GENDER!="")
				submitform(null, 'form1');
		}
	

 },[wptapp]);

useEffect(() => {

	checkMedRec();

 },[wptapp.MED_REC]);


function checkMedRec(){

console.log("checkMedRec() wptapp.MED_REC: "+wptapp.MED_REC);

	if (wptapp.MED_REC!=undefined && document.getElementsByName('MED_CERT_ISSUE_DATE')[0]){
		const value=wptapp.MED_REC;
		document.getElementsByName('MED_CERT_ISSUE_DATE')[0].required=(value=='1');
		document.getElementsByName('MED_CERT_EXPIRE_DATE')[0].required=(value=='1');

		document.getElementsByName('MED_CERT_ISSUE_DATE')[0].disabled=(value=='0');
		document.getElementsByName('MED_CERT_EXPIRE_DATE')[0].disabled=(value=='0');
		}
	
}//end func

function aftergetlcrstartoptions(res){

let tempcountryoptions=[], tempagencyoptions=[], temppayperiodoptions=[], tempoccupationoptions=[];
let templcrtypeoptions=[], templocationoptions=[], tempstatusoptions=[], tempreviewtypeoptions=[];

res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const opt=col['OPT'];
	const val=col['VAL'];
	
	
	if (combo=='country')
		tempcountryoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='agency')
		tempagencyoptions.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='payperiod')
		temppayperiodoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='occupation')
		tempoccupationoptions.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='lcrtype')
		templcrtypeoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='location')
		templocationoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='status')
		tempstatusoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='reviewtype')
		tempreviewtypeoptions.push(<option key={key} value={val}  >{opt}</option>);
	

	});//end map

setCountryoptions(tempcountryoptions);
setAgencyoptions(tempagencyoptions);
setPayperiodoptions(temppayperiodoptions);
setOccupationoptions(tempoccupationoptions);
setLcrtypeoptions(templcrtypeoptions);
setLocationoptions(templocationoptions);
setStatusoptions(tempstatusoptions);
setReviewtypeoptions(tempreviewtypeoptions)
}//end func


async function getlcrstartoptions(e){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

 await fetch(resturl+'rarwptprocess/getlcrstartoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetlcrstartoptions(res) )
      .catch(err => console.log(err));

}//end func


async function getwptapp(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:wptapp.WPT_APP_ID} )
  };		

  await fetch(resturl+'rarwpform/getwptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptapp(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwptapp(res){
	if (res.length)
		if (res.length==1){
			//setWptapp(res[0]);
			//let datas={};
			let datas=wptapp;

			for(var attributename in res[0]){
					const data=res[0][attributename];
					datas[attributename] = (data==null)?'':data;
				}//end for	
			
			//console.log('datas: '+JSON.stringify(datas) );
			setWptapp((prev)=>{
				return {...prev, datas}
			});
			//console.log('aftergetwptapp: '+res[0].MPE_OCCUPATION);
			}	
}//end func



function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func




function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function handleBlur(e){
	const {name, value} = e.target;

let TRY_FIND_PERSON_ID=false;
//flag TRY_FIND_PERSON_ID if personId not set and one of the citeria changed
if (1*wptapp.PERSON_ID<2){
	if (name=='MPE_FIRST_NAME' || name=='MPE_LAST_NAME' || name=='MPE_DOB' || name=='MPE_GENDER')
		TRY_FIND_PERSON_ID=true;

	if (TRY_FIND_PERSON_ID!=wptapp.TRY_FIND_PERSON_ID)	
		setWptapp((prev)=>{
			return {...prev, TRY_FIND_PERSON_ID:TRY_FIND_PERSON_ID}
		});
	}//end if
	
	
}//end func
	
function handleChange(e){
	
	e.preventDefault();
	
	if (document.getElementById("btncreateperson"))
		document.getElementById("btncreateperson").style.visibility="hidden";
	
	const {name, value} = e.target;


		
	setWptapp((prev)=>{
		return {...prev, [name]:value}
	});
	

	
		document.getElementById('btnsave1').style.visibility = "visible";
		document.getElementById('btnsave2').style.visibility = "visible";

	
}//end func

function openCity(evt, cityName) {
	
	
	
  
  const tabcontent = document.getElementsByClassName("tabcontent");
  
  for (var i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  const tablinks = document.getElementsByClassName("tablinks");
  
  for (var i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  
  if (document.getElementById(cityName))
	document.getElementById(cityName).style.display = "block";

	if (evt.currentTarget)
		evt.currentTarget.className += " active";
	
	
	if (cityName=="lcrapptc" && document.getElementsByName("MPE_SALARY_AMT")[0])
		document.getElementsByName("MPE_SALARY_AMT")[0].focus();
	
  /*
  removed the below bc for some strange reason the page reloads when setCity is called
  setCity({name:cityName});
  */
}//end func


async function tryCreateperson(e){
	if (e)
		e.preventDefault();

const result=window.confirm("Will try create a new person.  Proceed?");
if (result==false)
	return;

	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, WPT_APP_ID: wptapp.WPT_APP_ID
		};
	
	
	setDowait({show:true});
			setWptapp((prev)=>{
				return {...prev, TRY_FIND_PERSON_ID:false}
			});

	if (document.getElementById("btncreateperson"))
		document.getElementById("btncreateperson").style.visibility="hidden";

			
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwptprocess/createpersonfromwptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftercreatepersonfromwptapp(res) )
      .catch(err => console.log(err));
	  
}//end func


function aftercreatepersonfromwptapp(res){
	
	setDowait({show:false});
	console.log(JSON.stringify(res));
	let NEW_PERSON_ID = 0;
	
	if (res.length)
		if (res.length>0){
			NEW_PERSON_ID = res[0].PERSON_ID;
			}//end if
	
	if (NEW_PERSON_ID>0)
		setWptapp((prev)=>{
			return {...prev, PERSON_ID: NEW_PERSON_ID}
		});
		
}//end func


/*
tcilandregistry%40gov.tc
UPDATE WPT_APP SET
MPE_FIRST_NAME=NULL
, MPE_LAST_NAME=NULL
, MPE_DOB=NULL
, MPE_GENDER=NULL
, MPE_PASSPORT_NBR=NULL
, IMG_REF=NULL
, LBR_CLR_APP_ID=NULL
, PERSON_ID=NULL
, EMPL_ID=NULL
, MPE_BIRTH_COUNTRY=NULL
, MPE_CITZN_COUNTRY1=NULL
, MPE_PASSPORT_CTY=NULL
WHERE WPT_APP_ID=2015
AND REF_NUM='BCD01cr'
2015	BCD01cr	S84442
*/

async function submitform(e, formId){
	//console.log('submitform1');
	if (e)
		e.preventDefault();
	
	let lsFld="";
	if (formId=="form1")
		lsFld="WPT_APP_ID, IMG_REF, MPE_FIRST_NAME, MPE_LAST_NAME, MPE_OTHER_NAMES, MPE_DOB, MPE_GENDER, MPE_PASSPORT_CTY, MPE_PASSPORT_NBR, MPE_BIRTH_COUNTRY, MPE_CITZN_COUNTRY1, MPE_ADDRESS, MPE_RACE, MPE_NIB_NBR, MPE_NHIB_NBR";
	else
		lsFld="WPT_APP_ID, APP_TYPE_ID, TC_ISLAND, MPE_SALARY_AMT, MPE_SALARY_PRD, MED_REC, MED_CERT_ISSUE_DATE, MED_CERT_EXPIRE_DATE, WRK_CONTRACT_START, WRK_CONTRACT_END, AGENCY, MPE_OCCUPATION, REVIEW_TYPE, COMMENTS, FORM_DROP_OFF_DATE, VOUCHER_NBRS";
	
	var arrFld=lsFld.split(",");
	const formdata={};
	for (var i=0; i<arrFld.length; i++){
		const fld=arrFld[i].trim();
		formdata[fld]=wptapp[fld];
		}//end for
		
	
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, FORMID: formId
		, formdata: formdata
		};
	
	
	setDowait({show:true});
			setWptapp((prev)=>{
				return {...prev, TRY_FIND_PERSON_ID:false}
			});
			
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwptprocess/updatestartlcrapp',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatestartlcrapp(res) )
      .catch(err => console.log(err));
	  
}//end func


function afterupdatestartlcrapp(res){
	
	setDowait({show:false});
	console.log(JSON.stringify(res));
	
	let UPDATE_COUNT=0;
	let OLD_LBR_CLR_APP_ID=0;
	let NEW_LBR_CLR_APP_ID=0;
	
	
	if (res.length)
		if (res.length>0){
			UPDATE_COUNT=res[0].UPDATE_COUNT;
			OLD_LBR_CLR_APP_ID=res[0].OLD_LBR_CLR_APP_ID;
			NEW_LBR_CLR_APP_ID=res[0].NEW_LBR_CLR_APP_ID;
			setWptapp((prev)=>{
				return {...prev, IMG_REF:res[0].IMG_REF, PERSON_ID:res[0].PERSON_ID, LBR_CLR_APP_ID:res[0].NEW_LBR_CLR_APP_ID, TRY_FIND_PERSON_ID:false}
			});
			
			if (document.getElementById("btncreateperson"))
				document.getElementById("btncreateperson").style.visibility=(res[0].PROMPT_CREATE_PERSON==1)?"visible":"hidden";
				
			}//end if
	
	if (OLD_LBR_CLR_APP_ID>0)
		showsnackbar("record update blocked because a Labour Clearance Id# is already assigned");
	else if (NEW_LBR_CLR_APP_ID>0){
		showsnackbar("success! new Labour Clearance Id# "+NEW_LBR_CLR_APP_ID+" is assigned");
		//getwptapp();
		}
	else if (UPDATE_COUNT>0)
		showsnackbar("# of rows updated: "+UPDATE_COUNT);
	else
		showsnackbar("something went wrong.  please try again");
}//end func




/*
let refnum=null, refurl=null;
if (wptapp.REF_NUM){
	refnum=wptapp.REF_NUM;
	refurl=sessionStorage.getItem("UPLOADURL")+refnum+"/";
	console.log('refurl: '+refurl);
	}//end if
*/


function selectedFilesChange(event, elemId){
//console.log('selectedFilesChange index: '+index);

if (event.target.files.length>1){
	showsnackbar("upload only one file please");
	return;
	}
else if (event.target.files.length==0)
	return;
	
const fileName=event.target.files[0].name;
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);

const lsExtension="png";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	document.getElementById(elemId).value='';
	showsnackbar("error: the uploaded file must have one of these extensions: "+lsExtension);
	return;
	}//end if		

//if (selectedFiles.length==0)
	//addSubmitEventListener('form1', subEvtLsrCallback);
const i=0;//selectedFiles.length
//console.log('selectedFiles.length: '+i);
const uploadFileName=elemId=="photo_file"?wptapp.WORK_PERMIT_ID+".png":wptapp.WORK_PERMIT_ID+".png";
let temp=selectedFiles;
temp[i]={file:event.target.files[0], name:uploadFileName, ext:fileExtension};
setSelectedFiles((prev)=>{
	return [...temp]/*return [...prev, ...temp]*/
});

if (document.getElementById("btnupload").classList.contains("hidden"))
	document.getElementById("btnupload").classList.remove("hidden");


}//end func


async function uploadmpefoto(fileName){
	
	
	if (wptapp.LBR_CLR_APP_ID!=""){
		window.alert("not allowed after Labour Clearance Id # is assigend");
		return;
		}
	
	console.log('uploadmpefoto: '+selectedFiles.length);
	
//setAxiofl({ selectedFile: event.target.files });	
	//event.target.files
/*
ensure the below line in node js has the correct array size of 1 
router.post('/uploadfiles', upload.array('filesupload',1), (req, res, next) => {
*/	
 
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();

form.append('REF_NUM', wptapp.REF_NUM);


form.append('FOTO_EXT', "nil");
//let formfiles={foto:false,sign:false,scans:false};
//let filenames={foto:''};

let numfilesupload=0;
let currFile = null;
for (var i=0; i<selectedFiles.length; i++){
	//new File([""], filepath);
	currFile=new File( [selectedFiles[i].file], fileName);
	numfilesupload++;
	}//end for

//form.append('filenames', filenames);
//form.append('FOTO', filenames.foto);

if (currFile!=null)	{
	form.append('filesupload', currFile);
	const request_config = {
		onUploadProgress: data => {
		  //Set the progress value to show the progress bard
		  setProgress({perct:Math.round((100 * data.loaded) / data.total)});
		},
	};
	setDowait({show:true});
	await axios.post(resturl+'rarwpform/uploadmpefoto', form, request_config)
	.then(res => afteruploadmpefoto(res.data, fileName));
	
	}

}//end func


function afteruploadmpefoto(data, fileName){
	//console.log('afteruploadmpefoto: '+JSON.stringify(data));


	setDowait({show:false});
	if (fileName=="sign.png" && document.getElementById("signat_img")){
		const signat_img=document.getElementById("signat_img");
		const temp_src=signat_img.src;
		console.log("temp_src: "+temp_src);
		signat_img.src = null;
		
		signat_img.src = temp_src;
		//+"?" + new Date().getTime();
		}
	


}//end func

function voucherstip(e){
	e.preventDefault();
	showsnackbar("the last 4 digists of each voucher is sufficient.<br/>use comma between #s");
	//e.target.select();	
	
}//end func

function gotoProcesslcr(e){
	e.preventDefault();
	if (wptapp.LBR_CLR_APP_ID==""){
		document.getElementById('btnprocesslcr').style.visibility='hidden';
		showsnackbar("There is no Labour Clearance Id # assigned");
		}
	else
		navigate("/lcrprocess", {state:{LBR_CLR_APP_ID:wptapp.LBR_CLR_APP_ID, WPT_APP_ID:wptapp.WPT_APP_ID}});
}//end func



function getarrmpenames(IMG_REF){



if (IMG_REF.trim().length<4)
	return;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {IMG_REF:IMG_REF} )
  };		

  fetch(resturl+'rarwpform/getmpenames',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetarrmpenames(res) )
      .catch(err => console.log(err));

}//end func

function aftergetarrmpenames(res){

if (!res.length){
	return;
	}//end if

let temp=[], options=[];

res.map((col, index) => {
	const key="mpenameoption_"+index;
	const FIRST_NAME=""+col['FIRST_NAME'];
	const PERSON_ID=col['PERSON_ID'];
	
	temp.push(
	<tr key={key} >
	<td >{col['GENDER']}</td>
	<td >{col['DOB']}</td>
	<td ><input type="radio" id={key} onClick={(e)=>{ document.getElementById("btncopyperson").style.visibility="visible"; setWptapp((prev)=>{return {...prev, PERSON_ID_FROM_LIST:PERSON_ID}}) }} /><label htmlFor={key} className="hand" >{FIRST_NAME}</label></td>
	<td >{col['LAST_NAME']}</td>
	</tr>
	);
	});//end map

setTblperson(temp);
//options.push(<option value='-' >* none of the above *</option>);

//setCombompenames(options);


}//end func
	
	

async function copypersontowptapp(){

toggleModalsm();

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME: sessionStorage.getItem("USERNAME"), WPT_APP_ID:wptapp.WPT_APP_ID, PERSON_ID:wptapp.PERSON_ID_FROM_LIST} )
  };		

 await fetch(resturl+'rarwptprocess/copypersontowptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftercopypersontowptapp(res) )
      .catch(err => console.log(err));

}//end func

function aftercopypersontowptapp(res){
	if (res.length){
		setWptapp((prev)=>{
			return {
				...prev
				, PERSON_ID_FROM_LIST: 0
				, PERSON_ID: res[0].PERSON_ID
				, IMG_REF: res[0].IMG_REF
				, MPE_TITLE: res[0].MPE_TITLE
				, MPE_FIRST_NAME: res[0].MPE_FIRST_NAME
				, MPE_LAST_NAME: res[0].MPE_LAST_NAME
				, MPE_OTHER_NAMES: res[0].MPE_OTHER_NAMES
				, MPE_DOB: res[0].MPE_DOB
				, MPE_GENDER: res[0].MPE_GENDER
				, MPE_BIRTH_COUNTRY: res[0].MPE_BIRTH_COUNTRY
				, MPE_CITZN_COUNTRY1: res[0].MPE_CITZN_COUNTRY1
				, MPE_PASSPORT_NBR: res[0].MPE_PASSPORT_NBR
				, MPE_RACE: res[0].MPE_RACE
				, MPE_LANGUAGE1: res[0].MPE_LANGUAGE1
				, MPE_LANGUAGE2: res[0].MPE_LANGUAGE2
				 }
		});
		}//end if
		






}//end func
	
  return (
    <>
  <h4 align='center' className="Acme" style={{ marginBottom:"4px", color:"brown",fontSize:"22px"}} >
  New Labour Clearance Application - {wptapp.REF_NUM}
  </h4>
	
	<div style={{color:"navy"}} align='center' >
	To get a Labour Clearance Id #, please fill out the Labour Clearance details (it then goes to Process LC)
	</div>
	{/* 
	<span style={{width:"200px",backgroundColor:"green"}}>appe</span> 
	: <span style={{color:"Brown"}}>{wptapp.MPE_FIRST_NAME+" "+wptapp.MPE_LAST_NAME}</span>
	*/}
	
	<div className="tab">
  <button className="tablinks" id='person' onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Applicant Details</button>
	  {
		  wptapp.PERSON_ID>1 &&
		  <button className="tablinks" id='lcrapp'    onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Labour Clearance Details</button>
	  }


	</div>
	{/*
	<tr  key="tr_APP_ID" >
	<td align='right' >Application Id: </td>
	<td align='left' >{wptapp.LBR_CLR_APP_ID}</td>
	</tr>
*/}

<div id="lcrapptc" className="tabcontent">
{/*<h4 align='center' >Labour Clearance Details</h4>


*/}
  
	
	<form method="POST" id="form1" onSubmit={(e)=>{submitform(e, 'form2');}} >	
	<table align='center' >
	<tbody>
	<tr valign="top" >
	<td align="center">
		<table align='center' >
		<tbody>

		
		<tr  key="tr_WPT_APP_ID" >
		<td align='right' >APS Id #: </td>
		<td align='left' >{wptapp.WPT_APP_ID}</td>
		</tr>	

		<tr  key="tr_LBR_CLR_APP_ID" >
		<td align='right' >
		<a href="#" id="btnprocesslcr" onClick={(e)=>{gotoProcesslcr(e);}} 
		title="go to Process Labour Clearance"><img src="img/openfolderarrow.png" border="0" /></a>
		&nbsp;Labour Clearance Id #: </td>
		<td align='left' className="boldbrown" >{wptapp.LBR_CLR_APP_ID}</td>
		</tr>	
		
		<tr  key="tr_LBR_CLR_NO" >
		<td align='right' ><input defaultValue={wptapp.PERSON_ID} title="Person Id #" readOnly className="gnsbro" size="4"  onFocus={(e)=>{e.target.select();}}  style={{textAlign:"center", color:"navy"}} />&nbsp;&nbsp;Immigration Ref. #: </td>
		<td align='left' >{wptapp.IMG_REF}</td>
		</tr>

		<tr  key="tr_APP_TYPE" >
		<td align='right' >Applicaiton Type: </td>
		<td align='left' >
		<select name="APP_TYPE_ID" value={wptapp.APP_TYPE_ID?? "" } required onChange={(e)=>{handleChange(e);}} >
		<option value='' ></option>
		{lcrtypeoptions}
		</select>
		</td>
		</tr>	

		<tr  key="tr_STATUS" >
		<td align='right' >Status: </td>
		<td align='left' ><input type="text" defaultValue={wptapp.WPT_STATUS} readOnly className="gnsbro" onFocus={(e)=>{e.target.select();}} /></td>
		</tr>	

		<tr  key="tr_DATE_RCV" >
		<td align='right' >Date Received: </td>
		<td align='left' ><input name="FORM_DROP_OFF_DATE" type="date" value={wptapp.FORM_DROP_OFF_DATE?? "" } required onChange={(e)=>{handleChange(e);}} /></td>
		</tr>	

		<tr  key="tr_LOCATION" >
		<td align='right' >Location: </td>
		<td align='left' >
		<select name="TC_ISLAND" value={wptapp.TC_ISLAND?? "" } required onChange={(e)=>{handleChange(e);}}  >
		<option value='' ></option>
		{locationoptions}
		</select>
		</td>
		</tr>

		<tr key="tr_WAGES" >
		<td align='right' >Salary Amount (US $): </td>
		<td align='left' ><input type="text" name="MPE_SALARY_AMT" size="9" style={{textAlign:"center"}} value={wptapp.MPE_SALARY_AMT?? "" } required onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		</tr>
		<tr key="tr_WAGE_prd" >
		<td align='right' >Salary Period: </td>
		<td align='left' >
		<select name="MPE_SALARY_PRD" value={wptapp.MPE_SALARY_PRD?? "" } required onChange={(e)=>{handleChange(e);}}  >
		<option value='' ></option>
		{payperiodoptions}
		</select>	
		</td>
		</tr>	

		<tr key="tr_MED_REC" >
		<td align='right' >Medical Received: </td>
		<td align='left' >
		<select name="MED_REC" value={wptapp.MED_REC?? "" } required onChange={(e)=>{handleChange(e);}}  >
		{yesnooptions}
		</select>	
		</td>
		</tr>	

		<tr key="tr_MED_CERT_START" >
		<td align='right' >Medical Cert. Issue Date: </td>
		<td align='left' ><input name="MED_CERT_ISSUE_DATE" type="date" value={wptapp.MED_CERT_ISSUE_DATE?? "" } required onChange={(e)=>{handleChange(e);}} /></td>
		</tr>
		<tr key="tr_MED_CERT_END" >
		<td align='right' >Medical Cert. Expire Date: </td>
		<td align='left' ><input name="MED_CERT_EXPIRE_DATE" type="date" value={wptapp.MED_CERT_EXPIRE_DATE?? "" } required onChange={(e)=>{handleChange(e);}} /></td>
		</tr>

		<tr  key="tr_CREATE_USER	" >
		<td align='right' >Created By: </td>
		<td align='left' >{wptapp.CREATE_USER	}</td>
		</tr>

		<tr  key="tr_CREATE_DATE	" >
		<td align='right' >Created Date: </td>
		<td align='left' >{wptapp.CHR_CREATE_DATE	}</td>
		</tr>

		{/*
		<tr key="tr_CEARANCE_START" >
		<td align='right' >Clearance Issue Date: </td>
		<td align='left' ><input name="LBR_CLR_ISSUE_DATE" type="date" value={wptapp.LBR_CLR_ISSUE_DATE?? "" } required onChange={(e)=>{handleChange(e);}} /></td>
		</tr>
		<tr key="tr_CEARANCE_END" >
		<td align='right' >Clearance Expire Date: </td>
		<td align='left' ><input name="LBR_CLR_EXPIRE_DATE" type="date" value={wptapp.LBR_CLR_EXPIRE_DATE?? "" } required onChange={(e)=>{handleChange(e);}} /></td>
		</tr>
		
		*/}


		</tbody>		
		</table>
	
	</td>
	<td align="center" width="20" >&nbsp;</td>
	<td align="center">

		<table align='center' >
		<tbody>

		<tr  key="tr_AGENCY" >
		<td align='right' >Agency: </td>
		<td align='left' >
		<select name="AGENCY" value={wptapp.AGENCY?? "" } required onChange={(e)=>{handleChange(e);}} style={{width:"200px"}} >
		{agencyoptions}
		</select>
		</td>
		</tr>

		<tr key="tr_WRK_CONTRACT_START" >
		<td align='right' >Contract Start Date: </td>
		<td align='left' ><input name="WRK_CONTRACT_START" type="date" value={wptapp.WRK_CONTRACT_START?? "" } required onChange={(e)=>{handleChange(e);}} /></td>
		</tr>
		<tr key="tr_WRK_CONTRACT_END" >
		<td align='right' >Contract End Date: </td>
		<td align='left' ><input name="WRK_CONTRACT_END" type="date" value={wptapp.WRK_CONTRACT_END?? "" } required onChange={(e)=>{handleChange(e);}} /></td>
		</tr>

		<tr  key="tr_MPR_NAME" >
		<td align='right' ><input defaultValue={wptapp.EMPL_ID} title="Employer Id #" readOnly className="gnsbro" size="4"  onFocus={(e)=>{e.target.select();}}  style={{textAlign:"center", color:"navy"}} />&nbsp;&nbsp;Employer: </td>
		<td align='left' ><input type="text" defaultValue={wptapp.MPR_NAME} readOnly className="gnsbro" onFocus={(e)=>{e.target.select();}} /></td>
		</tr>

		<tr key="tr_OCCUPATION" >
		<td align='right' >Occupation:</td>
		<td align='left' >
		<select name="MPE_OCCUPATION" value={wptapp.MPE_OCCUPATION?? "" } required onChange={(e)=>{handleChange(e);}} style={{width:"200px"}} >
		<option value='' ></option>
		{occupationoptions}
		</select>
		</td>
		</tr>


		<tr key="tr_REVIEW_TYPE" >
		<td align='right' >Review Type: </td>
		<td align='left' >
		<select name="REVIEW_TYPE" value={wptapp.REVIEW_TYPE?? "" } required onChange={(e)=>{handleChange(e);}} style={{width:"200px"}} >
		<option value='' ></option>
		{reviewtypeoptions}
		</select>
		</td>
		</tr>


		<tr key="tr_COMMENTS" >
		<td align='right' >Comments: </td>
		<td align='left' ><textarea name="COMMENTS" value={wptapp.COMMENTS} cols="30" rows="5"  onChange={(e)=>{handleChange(e);}}  onFocus={(e)=>{e.target.select();}} ></textarea></td>
		</tr>
		
		<tr key="tr_VOUCHER_NBRS" >
		<td align='right' title="the last 4 digists of each voucher is sufficient. use comma between #s" >
		<a href="#" onClick={(e)=>{voucherstip(e);}} ><img src="img/help.png" border="0" /></a> Voucher #s: </td>
		<td align='left' ><input name="VOUCHER_NBRS" type="text" size="30" style={{textAlign:"center"}} value={wptapp.VOUCHER_NBRS?? "" } required onChange={(e)=>{handleChange(e);}}  onFocus={(e)=>{e.target.select()}} autoComplete="off" /></td>
		</tr>	

		{/*
		<tr  key="tr_CREATE_USER	" >
		<td align='right' >Created By: </td>
		<td align='left' >{wptapp.CREATE_USER	}</td>
		</tr>

		<tr  key="tr_CREATE_DATE	" >
		<td align='right' >Created Date: </td>
		<td align='left' >{wptapp.CREATE_DATE	}</td>
		</tr>
		*/}


		<tr  key="tr_BTN_SAVE1" valign="top" >
		<td align='right' >&nbsp; </td>
		<td align='left' >
		
			{dowait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
			{
			!dowait.show && 
			<input type="submit" id='btnsave1' className="button" value="save labour clearance details"  style={{visibility:"hidden"}} />
			}
		
		</td>
		</tr>


		<tr  key="tr_UPDATE_USER	" >
		<td align='right' >Updated By: </td>
		<td align='left' >{wptapp.MODIFY_USER	}</td>
		</tr>

		<tr  key="tr_UPDATE_DATE	" >
		<td align='right' >Updated Date: </td>
		<td align='left' >{wptapp.CHR_MODIFY_DATE	}</td>
		</tr>


		{/*
		<tr key="key_tr_LOCATION_ID" >
		<td align='right' >Location:</td>
		<td align='left' ><select key="input_LOCATION_ID" name='LOCATION_ID' defaultValue={wptapp.LOCATION_ID}   ><option defaultValue='' ></option>{locations}</select></td>
		</tr>
		
		*/}	
		</tbody>
		</table>
	
	</td>
	</tr>
	</tbody>
	</table>	
	</form>


	

</div>

<div id="persontc" className="tabcontent">
{/*<h4 align='center' >Applicant Details</h4>*/}

	<form method="POST" id="form2" onSubmit={(e)=>{submitform(e, 'form1');}} >
	<table align='center' >
	<tbody>

	<tr  key="tr_IMG_REF" >
	<td align='right' >Immigration Ref #: </td>
	<td align='left' >
		<input type="text" name="IMG_REF" value={wptapp.IMG_REF?? "" } size="7" onChange={(e)=>{handleChange(e);}} required onBlur={(e)=>{getarrmpenames(e.target.value);}}  onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" />
		&nbsp;&nbsp;
		<input defaultValue={wptapp.PERSON_ID} id="input_person_id_1"  title="Person Id #" readOnly className="gnsbro" size="4"  onFocus={(e)=>{e.target.select();}}  style={{textAlign:"center", color:"navy"}} />
		&nbsp;&nbsp;<a href="#" id="btncreateperson" onClick={(e)=>{tryCreateperson(e);}} style={{visibility:"hidden"}} title="click to add this new person" ><img src="img/magic.png" border="0" /></a>

	</td>
	<td align="center" width="20" ></td>
	<td align='right' >Address: </td>
	<td align='left' ><input type="text" name="MPE_ADDRESS" value={wptapp.MPE_ADDRESS?? "" } required onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
	</tr>



	<tr  key="tr_MPE_FIRST_NAME" >
	<td align='right' >First Name: </td>
	<td align='left' ><input type="text" name="MPE_FIRST_NAME" value={wptapp.MPE_FIRST_NAME?? "" } required onChange={(e)=>{handleChange(e);}}  onBlur={(e)=>{handleBlur(e);}}  onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
	<td align="center" width="20" ></td>
	<td align='right' >Race: </td>
	<td align='left' ><input type="text" name="MPE_RACE" value={wptapp.MPE_RACE?? "" } required onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
	</tr>
	
	<tr  key="tr_MPE_OTHER_NAMES" >
	<td align='right' >Middle Names: </td>
	<td align='left' ><input type="text" name="MPE_OTHER_NAMES" value={wptapp.MPE_OTHER_NAMES?? "" } onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
	<td align="center" width="20" ></td>
	<td align='right' >Country of Birth: </td>
	<td align='left' >
	<select name="MPE_BIRTH_COUNTRY" value={wptapp.MPE_BIRTH_COUNTRY?? "" } required onChange={(e)=>{handleChange(e);}} style={{width:"200px"}} >
	<option value='' ></option>
	{countryoptions}
	</select>	
	</td>
	</tr>

	<tr  key="tr_MPE_LAST_NAME" >
	<td align='right' >Last Name: </td>
	<td align='left' ><input type="text" name="MPE_LAST_NAME" value={wptapp.MPE_LAST_NAME?? "" } required onChange={(e)=>{handleChange(e);}}  onBlur={(e)=>{handleBlur(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
	<td align="center" width="20" ></td>
	<td align='right' >Nationality: </td>
	<td align='left' >
	<select name="MPE_CITZN_COUNTRY1" value={wptapp.MPE_CITZN_COUNTRY1?? "" } required onChange={(e)=>{handleChange(e);}} style={{width:"200px"}} >
	<option value='' ></option>
	{countryoptions}
	</select>	
	</td>
	</tr>
	
	
	<tr  key="tr_MPE_DOB" >
	<td align='right' >Date of Birth: </td>
	<td align='left' ><input name="MPE_DOB" type="date" value={wptapp.MPE_DOB?? "" } required onChange={(e)=>{handleChange(e);}}  onBlur={(e)=>{handleBlur(e);}} /></td>
	<td align="center" width="20" ></td>
	<td align='right' >NIB #: </td>
	<td align='left' ><input type="text" name="MPE_NIB_NBR" value={wptapp.MPE_NIB_NBR?? "" } onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
	</tr>


	<tr  key="tr_GENDER" >
	<td align='right' >Gender: </td>
	<td align='left' >
	<select name="MPE_GENDER" value={wptapp.MPE_GENDER?? "" } required onChange={(e)=>{handleChange(e);}}  onBlur={(e)=>{handleBlur(e);}}  style={{width:"200px"}} >
	<option value='' ></option>
	{genderoptions}
	</select>	
	</td>
	<td align="center" width="20" ></td>
	<td align='right' >NHIB #: </td>
	<td align='left' ><input type="text" name="MPE_NHIB_NBR" value={wptapp.MPE_NHIB_NBR?? "" } onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
	</tr>
	
	
	<tr  key="tr_MPE_PPT" >
	<td align='right' >Passport Number: </td>
	<td align='left' ><input type="text" name="MPE_PASSPORT_NBR" value={wptapp.MPE_PASSPORT_NBR?? "" } required onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
	<td align="center" width="20" ></td>
	<td align='center' colSpan="2" >
			{dowait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
			{
			!dowait.show && 
			<input type="submit" id='btnsave2' className="button" value="save applicant details" style={{visibility:"hidden"}} />
			}	
	</td>
	</tr>


	<tr  key="tr_MPE_PASSPORT_CTY" >
	<td align='right' >Passport Country of Issue: </td>
	<td align='left' >
	<select name="MPE_PASSPORT_CTY" value={wptapp.MPE_PASSPORT_CTY?? "" } required onChange={(e)=>{handleChange(e);}} style={{width:"200px"}} >
	<option value='' ></option>
	{countryoptions}
	</select>	
	</td>
	</tr>


	

	<tr  key="tr_HEAD_SHOT" valign="top"  >
	<td align='right' >Head Shot Photo:</td>
	<td align='left' >
		{wptapp.REF_NUM &&
		<img src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/foto.png"} border='0' height="150" />
		}	
	</td>
	<td align="center" width="20" ></td>
	<td align='right' >Signature Photo:</td>
	<td align='left' colSpan="1" >
			<img id='signat_img' src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/sign.png"} border='0' height="60" />
			{
			!dowait.show && <>
			<br/><input type="file" name="signat_file" accept=".png" onChange={(e)=>{selectedFilesChange(e, 'signat_file');}} />
			<br/><input type="button" id="btnupload" className="button hidden" onClick={(e)=>{uploadmpefoto("sign.png");}} value="upload signature" />
			</>
			}	
	</td>


	</tr>

	</tbody>
	</table>
	</form>
	

</div>
	
	

	
	
	


	<div id="snackbar">&nbsp;</div>

	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
			<p style={{fontWeight:"bold", color:"brown"}} >Please tick the correct person below if present</p>
			<table align="center" className="customers" >
			<thead>
			<tr>
			<th>Gender</th>
			<th>D.O.B.</th>
			<th>First Name</th>
			<th>Last Name</th>
			</tr>
			</thead>
			<tbody>
			{tblperson}
			</tbody>
			</table>
			
			<p><button className="button" id="btncopyperson" style={{visibility:"hidden"}} onClick={(e)=>{copypersontowptapp();}} >continue with selected person</button></p>
			</div>
		</div>
	</div>

    </>
  );
  


};


export default RenderStartLcrapp;